import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import MainPageSkeleton from "../../../components/loaders/MainPageSkeleton";
import Container from '@mui/material/Container';
import {useParams} from "react-router";
import {scrollTop} from "../../../../config/values";
import Title from "../../../components/elements/Title";
import SwiperSlider from "../../../components/elements/slider/SwiperSlider";
import BannerSliderItem from "../components/BannerItem";
import {connect, setStore} from "trim-redux";
import EditorPreviewHTML from "../../../components/editor/EditorPreviewHTML";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";

function ShowPageContent({classes,setting,slug,setPageData}){
    const { t } = useTranslation();

    const [page, setPage] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/front/page/${slug}`,config)
            .then(response => {
                setPage(response.data);
                setPageData(response.data);
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
                setStore({error:404})
            });
    }

    useEffect(() => {
        if (!fetching) {
            loadData();
        }
    },[slug]);

    return (
        <div>
            {
                loading ?
                    <AppCardLoaderFields/>
                    :
                    <EditorPreviewHTML html={page.data?.html} />
            }

        </div>
    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(ShowPageContent));
